import React from 'react';
import { PublicUsersProfileContextProvider } from '../../../services/public-users-profile/public-users-profile.context';
import { PublicProfile } from '../component/public-profile';

export const PublicProfileContainer = () => {
  return (
    <PublicUsersProfileContextProvider>
      <PublicProfile />
    </PublicUsersProfileContextProvider>
  );
};
